type ArgsType = {
  value: number
  style?: 'decimal' | 'currency' | 'percent' | 'unit'
  locale?: string
  currency?: string
  currencyDisplay?: 'symbol' | 'code' | 'name' | 'narrowSymbol'
  minimumFractionDigits?: number
  maximumFractionDigits?: number
}

const formatCurrency = ({
  value,
  style = 'currency',
  locale = 'zh-CN',
  currency = 'CNY',
  currencyDisplay = 'symbol',
  minimumFractionDigits,
  maximumFractionDigits = 2,
}: ArgsType) => {
  if (isNaN(value)) {
    return ''
  }

  if (typeof minimumFractionDigits !== 'number') {
    minimumFractionDigits = Math.min(2, maximumFractionDigits)
  }

  try {
    const formatter = new Intl.NumberFormat(locale, {
      style,
      currency,
      currencyDisplay,
      minimumFractionDigits,
      maximumFractionDigits,
    })
    return formatter.format(value)
  } catch {
    const formatter = new Intl.NumberFormat(locale, {
      style,
      currency,
      minimumFractionDigits,
      maximumFractionDigits,
    })
    return formatter.format(value)
  }
}

export default formatCurrency
